/* vue-kerlink version 3.0.3 */
/**
* @function generateRandomId
* @desc Generate a random ID (see https://stackoverflow.com/a/6860916/3493954)
* @param {string}  integer  - Length of the ID to generate
* @return {string} Result
*/
const generateRandomId = (length = 8) => {
  function S4 () { return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) }

  let id = '';
  while (id.length < length) {
    id += S4();
  }

  return id.substr(0, length)
};

export default generateRandomId;
